import { render, staticRenderFns } from "./create-damage-report.vue?vue&type=template&id=1721707e"
import script from "./create-damage-report.vue?vue&type=script&lang=ts"
export * from "./create-damage-report.vue?vue&type=script&lang=ts"
import style0 from "./create-damage-report.vue?vue&type=style&index=0&id=1721707e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports